import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Modal } from "react-responsive-modal";
import "../../styles/CustomModal.css";
import "react-responsive-modal/styles.css";
import { ThrooOrderType } from "../../recoil/type";
import OrderController, {
  OrderStatusType,
} from "../../controller/OrderController";
import moment from "moment";
import { getRecoil } from "recoil-nexus";
import { authState } from "../../recoil/auth";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  order: ThrooOrderType;
};

const ThrooRejectModal = ({
  isVisible,
  setVisible,
  order,
}: Props) => {
  const [type, setType] = useState<string>("가게 사정");

  const onCloseModal = () => {
    setVisible(false);
  };

  // orderStatus API
  const updateStatus = async () => {
    const oParams: OrderStatusType = {
      order_id: order.order_id.toString(),
      order_seq: 0,
      order_status: 4,
      table_area_nr: 0,
      table_nr: 0,
      store_id: order.store_id,
      parent_store_id: 0,
      cancel_description: type,
      user_token_id: getRecoil(authState).user_token_id,
      status_changed_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    //return;
    console.log("oParams", oParams);
    const oRes = await OrderController.updateStatus(oParams);

    if (oRes && oRes.data) {
      onCloseModal();
    }
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "rejectModalOverlay",
        modal: "rejectModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <h2>주문 거절 / 취소 사유</h2>
          <div className="listWrap">
            <button
              className={`typeBox ${type === "가게 사정" && "active"}`}
              onClick={() => setType("가게 사정")}
            >
              가게 사정
            </button>
            <button
              className={`typeBox ${type === "조리 지연" && "active"}`}
              onClick={() => setType("조리 지연")}
            >
              조리 지연
            </button>
            <button
              className={`typeBox ${type === "요청사항\n적용불가" && "active"}`}
              onClick={() => setType("요청사항\n적용불가")}
            >
              {`요청사항\n적용 불가`}
            </button>
            <button
              className={`typeBox ${type === "배달원 부재" && "active"}`}
              onClick={() => setType("배달원 부재")}
            >
              배달원 부재
            </button>
            <button
              className={`typeBox ${type === "재료 소진" && "active"}`}
              onClick={() => setType("재료 소진")}
            >
              재료 소진
            </button>
            <button
              className={`typeBox ${type === "고객 요청" && "active"}`}
              onClick={() => setType("고객 요청")}
            >
              고객 요청
            </button>
          </div>
          <button className="saveButton" onClick={updateStatus}>
            완료
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default ThrooRejectModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 7% 10% 5% 10%;
  }

  h2 {
    color: #333333;
    font-weight: 500;
    text-align: center;
  }

  .listWrap {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 24px 0;

    .typeBox {
      width: calc(94% / 3);
      height: 90px;
      border: 1px solid #a7a7a7;
      border-radius: 10px;
      margin: 1%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      line-height: 24px;
      font-weight: 500;
      color: #333333;
      white-space: pre-line;
    }
    .typeBox.active {
      background: #ecf7f4;
      color: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
  .saveButton {
    width: 100%;
    text-align: center;
    background: #4dd2ae;
    border-radius: 10px;
    padding: 12px 0;
    font-size: 24px;
    line-height: 30px;
    font-weight: 600;
    color: #ffffff;
  }
`;
